import { render, staticRenderFns } from "./common-image-viewer.vue?vue&type=template&id=66f2d65a&"
import script from "./common-image-viewer.vue?vue&type=script&lang=js&"
export * from "./common-image-viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../resource-manage/node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports